import { Snackbar } from '@mui/material';

import { useSnackbar } from '../hooks';

import { AppRoutes } from './router';
import { StyledAlert } from './main-router.styles';

type Props = {
  ProtectedRoute?: any;
};
export const MainRouter = ({ ProtectedRoute }: Props) => {
  const { open, message, severity, snackbarDuration, alertClose, handleOnClear, handleOnClose } = useSnackbar();

  return (
    <>
      <AppRoutes ProtectedRoute={ProtectedRoute} />;
      <Snackbar
        open={open}
        autoHideDuration={snackbarDuration}
        onClose={handleOnClose}
        TransitionProps={{
          onExited: handleOnClear
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <StyledAlert severity={severity} onClose={alertClose ? handleOnClose : undefined}>
          <div dangerouslySetInnerHTML={{ __html: message }} />
        </StyledAlert>
      </Snackbar>
    </>
  );
};
